export default "{\n    \"label_one\": \"Miembro del equipo\",\n    \"label_other\": \"{{count}} miembros del equipo\"\n}\n"